import { render, staticRenderFns } from "./CustomerTables.vue?vue&type=template&id=e6f141de&scoped=true"
import script from "./CustomerTables.vue?vue&type=script&lang=js"
export * from "./CustomerTables.vue?vue&type=script&lang=js"
import style0 from "./CustomerTables.vue?vue&type=style&index=0&id=e6f141de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f141de",
  null
  
)

export default component.exports